import { Component, Input, OnDestroy} from '@angular/core';
import { BreadcrumbInterface } from '../../services/breadcrumbs.service';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {environment} from "../../../../environments/environment";
import {DomSanitizer} from "@angular/platform-browser";
import { OnInit } from '@angular/core';
import { DeviceType } from '../../models/interfaces/device-type.type';
import { DeviceWidthService } from '../../services/width.service';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { PersonComponent } from '../person/person.component';
import { RoadDrawerDirective } from '../../directives/road-drawer.directive';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { NgIf } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-edu-element-module-title',
    templateUrl: './edu-element-module-title.component.html',
    styleUrls: ['./edu-element-module-title.component.scss'],
    animations: [
        trigger('animatedChangeLogo', [
            state('true', style({ opacity: 1 })),
            state('void', style({ opacity: 0 })),
            transition(':enter', [
                style({ opacity: 0 }),
                animate('700ms ease-in-out'),
            ]),
        ])
    ],
    standalone: true,
    imports: [NgIf, BreadcrumbsComponent, RoadDrawerDirective, PersonComponent, ProgressSpinnerComponent]
})

export class EduElementModuleTitleComponent implements OnInit, OnDestroy {

  deviceType: DeviceType = 'desktop';
  private destroy$ = new Subject<void>();

  get isParacelsus () {
    return environment.style === 'paracelsus'
  }

  get isHeader () {
    return true;
  }

  get logo() {
    return '/assets/images/logo/logo.png'
  }

  constructor(private domSanitizer: DomSanitizer,
    private deviceWidth: DeviceWidthService) {}

  @Input()
  moduleName: string | undefined;

  @Input()
  title: string | undefined;

  @Input()
  breadcrumbs!: BreadcrumbInterface[] | null;

  @Input()
  totalScore?: number;

  @Input()
  isStep?: any;

  ngOnInit() {
    this.deviceWidth.getDeviceType$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(type => {
      this.deviceType = type;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
